<template>
  <div class="processMonitoring">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Loading_Process') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Loading_quarter') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaLoadquarter"
          :otherData="{
            mediaName: '封柜过程(1/4)',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaLoadquarter',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Loading_half') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaLoadhalf"
          :otherData="{
            mediaName: '封柜过程(2/4)',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaLoadhalf',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Loading_three_quarter') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaLoadthreequarter"
          :otherData="{
            mediaName: '封柜过程(3/4)',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaLoadthreequarter',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Loading_Finished') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaLoadfinish"
          :otherData="{
            mediaName: '全部装完',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaLoadfinish',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Right_Door_Closed') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaRightclose"
          :otherData="{
            mediaName: '右侧柜门关闭',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaRightclose',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Both_Door_Closed') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaBothclose"
          :otherData="{
            mediaName: '双侧柜门关闭',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaBothclose',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Container_Sealing_Photo') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.lmediaSealphoto"
          :otherData="{
            mediaName: '封柜照片',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaSealphoto',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        style="margin-right: 20px;"
        :columns="columns"
        :dataSource="[data]"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.Reports.Nr'),
          align: 'center',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.LoadingReport.Order_Quantity_pcs'),
          dataIndex: 'progressQuantity',
          key: 'progressQuantity',
        },
        {
          title: this.$tc('lang.LoadingReport.Order_Cartons_CTN'),
          dataIndex: 'progressCarton',
          key: 'progressCarton',
        },
        {
          title: this.$tc('lang.LoadingReport.Actual_Loaded_Quantit_pcs'),
          dataIndex: 'progressActualquantity',
          key: 'progressActualquantity',
        },
        {
          title: this.$tc('lang.LoadingReport.Actual_Loaded_Cartons_CTN'),
          dataIndex: 'progressActualcarton',
          key: 'progressActualcarton',
        },
      ],
      data: {},
      id: this.$route.query.id,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      modalData: {},
    };
  },
  computed: {
    supervisionDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.supervisionDetails),
        );
      },
    },
    processMonitoring: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.supervisionImgList.processMonitoring,
          ),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/loadig-progress/getLoadigProgress', {
          lreportId: this.supervisionDetails.lreoprtId,
        })
        .then(data => {
          if (data) {
            this.data = data;
          } else {
            this.data = {};
          }
        })
        .catch(() => {
          this.data = {};
        });
    },
  },
};
</script>
<style lang="less">
.processMonitoring {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
